<template>
  <div class="Fuell-CreditCardsContainer">

    <card-item
      v-for="card in cards"
      @showCardDetailModal="showCardDetailModal"
      @checkPasscode="showCheckPasscodeModal"
      :card="card"
      :key="card.id"
    ></card-item>
    <card-detail-modal
      v-if="showCardDetailModalFlag"
      :open.sync="showCardDetailModalFlag"
      :cardId="cardId"
      @checkPasscode="showCheckPasscodeModal"
      @showTransactionDetail="showTransactionDetail"
      @showDownloadModal="showDownloadModal"
    ></card-detail-modal>
    <card-passcode-request-modal
      :open.sync="showCheckPasscodeModalFlag"
      :cardUserOwnerId="selectedCardInfo.cardUserOwnerId"
      :cardStatus="selectedCardInfo.cardStatus"
      @passCodeConfirm="confirmPasscode"
      v-if="showCheckPasscodeModalFlag"
    ></card-passcode-request-modal>
    <transaction-edit-modal
      v-if="showTransactionEditModalFlag"
      :transactionId.sync="transactionToEditId"
      :open.sync="showTransactionEditModalFlag"
      @showReceiptModal="showReceiptModal"
      @closeModal="handleCloseReceipts"
      @showTransactionModal="showTransactionModal"
    />
    <transaction-receipts-viewer-modal
      :open.sync="showTransactionReceiptModalFlag"
      v-if="showTransactionReceiptModalFlag"
      :transactionId.sync="transactionToShowReceiptId"
      :preloadReceiptId="preloadReceiptId"
    >
    </transaction-receipts-viewer-modal>
    <confirm-modal
      v-if="showFrozenCardModalFlag"
      :open.sync="showFrozenCardModalFlag"
      :modalClass="'ModalBox--400'"
      :title="'card_frozen_modal_title'"
      :message="'card_frozen_modal_description'"
      :acceptText="'card_frozen_modal_frozen'"
      :dismissText="'ACTION_CANCEL'"
      acceptBtnClass="blue"
      dismissBtnClass="danger"
      closeButton
      @accept="toggleCardStatus(selectedCardInfo)"
      @dismiss="closeModal"
    ></confirm-modal>
    <div class="row w-100 mx-auto">
      <div
        class="col-12 d-flex justify-content-center"
        v-if="isCallingCards"
      >
        <spinner />
      </div>
    </div>
    <confirm-modal
      v-if="showFrozenCardModalFlag"
      :open.sync="showFrozenCardModalFlag"
      :modalClass="'ModalBox--400'"
      :title="'card_frozen_modal_title'"
      :message="'card_frozen_modal_description'"
      :acceptText="'card_frozen_modal_frozen'"
      :dismissText="'ACTION_CANCEL'"
      acceptBtnClass="blue"
      dismissBtnClass="danger"
      closeButton
      @accept="toggleCardStatus(selectedCardInfo)"
      @dismiss="closeModal"
    ></confirm-modal>
  </div>
</template>

<script>
import CardItem from './CardItem'
import Spinner from '@/components/Commons/Spinner'
import _paginationHandlerMixin from '@/components/Commons/_mixins/_paginationHandlerMixin'
import _transactionsIndexViewShared from '@/modules/transactions/_mixins/_transactionsIndexViewShared'
const TransactionEditModal = () => import('@/modules/transactions/_components/_shared/TransactionsEditModal.vue')
const CardPasscodeRequestModal = () => import('./CardPasscodeRequestModal')
const CardDetailModal = () => import('./CardDetailModal')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'CardsContainer',
  components: { CardItem, Spinner, CardDetailModal, CardPasscodeRequestModal, TransactionEditModal, ConfirmModal },
  mixins: [_paginationHandlerMixin, _transactionsIndexViewShared],
  data () {
    return {
      cardId: 0,
      showCardDetailModalFlag: false,
      selectedCardInfo: {},
      showCheckPasscodeModalFlag: false,
      isSendingPasscode: false,
      showTransactionEditModalFlag: false,
      showFrozenCardModalFlag: false
    }
  },
  computed: {
    cards () {
      return this.$store.getters['CardsStore/cards'] || []
    },
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    },
    isAdmin () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    isSuperAdmin () {
      return this.$store.getters['LoginStore/isSuperAdmin']
    },
    currentPage () {
      return this.$store.getters['CardsStore/currentPage']
    },
    lastPage () {
      return this.$store.getters['CardsStore/lastPage']
    },
    isCallingCards () {
      return this.$store.getters['CardsStore/isCallingCards']
    }
  },
  methods: {
    closeModal () {
      this.showFrozenCardModalFlag = false
    },
    showDownloadModal (filters) {
      this.$emit('showDownloadModal', filters)
    },
    showCardDetailModal (event) {
      this.cardId = event
      this.showCardDetailModalFlag = true
    },
    showCheckPasscodeModal (event) {
      this.selectedCardInfo = event
      if (this.isUser) {
        this.showCheckPasscodeModalFlag = true
      }
      if ((this.isAdmin || this.isSuperAdmin) && this.selectedCardInfo.cardStatus === 'ACTIVE') {
        this.showFrozenCardModalFlag = true
      } else if (this.isAdmin || this.isSuperAdmin) {
        this.toggleCardStatus(event)
      }
    },
    handleCloseReceipts () {
      if (this.showTransactionReceiptModalFlag) {
        this.showTransactionReceiptModalFlag = false
        this.$store.dispatch('TransactionsStore/setReceiptModalIsOpen', false)
      }
    },
    nextPage () {
      this.$store.dispatch('CardsStore/nextCardsPage')
    },
    confirmPasscode (event) {
      let passcodeConfirmInfo = { ...event, ...this.selectedCardInfo }
      this.toggleCardStatus(passcodeConfirmInfo)
    },
    showTransactionDetail (event) {
      this.transactionToEditId = event
      this.showTransactionEditModalFlag = true
    },
    async toggleCardStatus (event) {
      if (event && event.cardStatus) {
        if (event.cardStatus === 'ACTIVE') {
          await this.$store.dispatch('CardsStore/freezeCard', {
            cardId: event.cardId,
            passcode: event.passcode,
            cardInfo: event.cardInfo
          })
        }

        if (event.cardStatus === 'FROZEN') {
          await this.$store.dispatch('CardsStore/activateCard', {
            cardId: event.cardId,
            passcode: event.passcode,
            cardInfo: event.cardInfo

          })
        }

        if (event.cardStatus === 'FROZEN_BY_ADMIN' && (this.isAdmin || this.isSuperAdmin)) {
          await this.$store.dispatch('CardsStore/activateCard', {
            cardId: event.cardId,
            passcode: event.passcode,
            cardInfo: event.cardInfo
          })
        }
        this.showCheckPasscodeModalFlag = false
      }
    }
  }

}
</script>
